import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "../views/layout/Layout";

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [{
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true
  },
  {
    path: "/404",
    component: () => import("@/views/404"),
    hidden: true
  },
  {
    path: "",
    component: Layout,
    redirect: "/home",
    children: [{
      path: "home",
      name: "home",
      component: () => import("@/views/home/index"),
      meta: {
        title: "首页",
        icon: "home"
      }
    }]
  }
];

export const asyncRouterMap = [{
    path: "/ums",
    component: Layout,
    redirect: "/ums/admin",
    name: "ums",
    meta: {
      title: "权限",
      icon: "ums"
    },
    children: [{
        path: "admin",
        name: "admin",
        component: () => import("@/views/ums/admin/index"),
        meta: {
          title: "用户列表",
          icon: "ums-admin"
        }
      },
      {
        path: "role",
        name: "role",
        component: () => import("@/views/ums/role/index"),
        meta: {
          title: "角色列表",
          icon: "ums-role"
        }
      },
      {
        path: "allocMenu",
        name: "allocMenu",
        component: () => import("@/views/ums/role/allocMenu"),
        meta: {
          title: "分配菜单"
        },
        hidden: true
      },
      {
        path: "allocResource",
        name: "allocResource",
        component: () => import("@/views/ums/role/allocResource"),
        meta: {
          title: "分配资源"
        },
        hidden: true
      },
      {
        path: "menu",
        name: "menu",
        component: () => import("@/views/ums/menu/index"),
        meta: {
          title: "菜单列表",
          icon: "ums-menu"
        }
      },
      {
        path: "addMenu",
        name: "addMenu",
        component: () => import("@/views/ums/menu/add"),
        meta: {
          title: "添加菜单"
        },
        hidden: true
      },
      {
        path: "updateMenu",
        name: "updateMenu",
        component: () => import("@/views/ums/menu/update"),
        meta: {
          title: "修改菜单"
        },
        hidden: true
      },
      {
        path: "resource",
        name: "resource",
        component: () => import("@/views/ums/resource/index"),
        meta: {
          title: "资源列表",
          icon: "ums-resource"
        }
      },
      {
        path: "resourceCategory",
        name: "resourceCategory",
        component: () => import("@/views/ums/resource/categoryList"),
        meta: {
          title: "资源分类"
        },
        hidden: true
      }
    ]
  },
  {
    path: "/phms",
    component: Layout,
    redirect: "/phms/orders",
    name: "phms",
    meta: {
      title: "我的药房",
      icon: "sms"
    },
    children: [
      /*{
              path: "drugs",
              name: "drugs",
              component: () => import("@/views/pharmacyMS/drugs/drugs"),
              meta: {
                title: "产品列表",
                icon: "product-list"
              }
            },*/
      {
        path: "drugsCount",
        name: "drugsCount",
        component: () => import("@/views/pharmacyMS/drugs/drugsCount"),
        meta: {
          title: "产品销售统计",
          icon: "product-list"
        }
      },
      {
        path: "drugsDeliveryCount",
        name: "drugsDeliveryCount",
        component: () => import("@/views/pharmacyMS/drugs/drugsDeliveryCount"),
        meta: {
          title: "产品发货统计",
          icon: "product-list"
        }
      },
      {
        path: "editDrugs",
        name: "editDrugs",
        component: () => import("@/views/pharmacyMS/drugs/editDrugs"),
        meta: {
          title: "编辑产品",
          icon: "product-list"
        },
        hidden: true
      },
      {
        path: "orders",
        name: "orders",
        component: () => import("@/views/pharmacyMS/orders/orders"),
        meta: {
          title: "订单",
          icon: "order"
        }
      },
      {
        path: "orderDetail",
        name: "orderDetail",
        component: () => import("@/views/pharmacyMS/orders/orderDetail"),
        meta: {
          title: "订单详情",
          icon: "order"
        },
        hidden: true
      },
      {
        path: "myVipShopOrder",
        name: "myVipShopOrder",
        component: () => import("@/views/pharmacyMS/orders/vipShopOrder"),
        meta: {
          title: "VIP商城订单",
          icon: "order"
        }
      },
      {
        path: "members",
        name: "members",
        component: () => import("@/views/pharmacyMS/members/members"),
        meta: {
          title: "员工列表",
          icon: "ums-role"
        }
      },
      {
        path: "stocks",
        name: "stocks",
        component: () => import("@/views/pharmacyMS/stocks/stocks"),
        meta: {
          title: "库存记录",
          icon: "ums-role"
        }
      }
    ]
  },
  {
    path: "/srm",
    component: Layout,
    redirect: "/srm/salesCount",
    name: "srm",
    meta: {
      title: "供应商管理",
      icon: "ums"
    },
    children: [{
        path: "salesCount",
        name: "salesCount",
        component: () => import("@/views/srm/salesCount/salesCount"),
        meta: {
          title: "业务统计",
          icon: "ums-role"
        }
      },
      {
        path: "supplierDrugs",
        name: "supplierDrugs",
        component: () => import("@/views/srm/supplierDrugs/supplierDrugs"),
        meta: {
          title: "供应商产品",
          icon: "product-cate"
        }
      },
      {
        path: "editDrugs",
        name: "editDrugs",
        component: () => import("@/views/pharmacyMS/drugs/editDrugs"),
        meta: {
          title: "编辑产品",
          icon: "product-list"
        },
        hidden: true
      },
      {
        path: "supplierDrugDetail",
        name: "supplierDrugDetail",
        component: () => import("@/views/srm/supplierDrugs/supplierDrugDetail"),
        meta: {
          title: "产品详情",
          icon: "product-cate"
        },
        hidden: true
      }
    ]
  },

  {
    path: "/subsidiaryMng",
    component: Layout,
    redirect: "/subsidiaryMng/listSubsidiary",
    name: "subsidiaryMng",
    meta: {
      title: "分公司管理",
      icon: "sms-subject"
    },
    children: [{
      path: "listSubsidiary",
      name: "listSubsidiary",
      component: () => import("@/views/srm/subsidiaryMng/listSubsidiary"),
      meta: {
        title: "分公司列表",
        icon: "sms-subject"
      }
    }]
  },
  {
    path: "/feedback",
    component: Layout,
    redirect: "/feedback/feedbackList",
    name: "feedback",
    meta: {
      title: "售后回馈",
      icon: "sms-subject"
    },
    children: [{
      path: "feedbackList",
      name: "feedbackList",
      component: () => import("@/views/srm/feedback/list"),
      meta: {
        title: "售后回馈",
        icon: "sms-subject"
      }
    }]
  },
  {
    path: "/stocksAll",
    component: Layout,
    redirect: "/stocksAll/stocksList",
    name: "stocksAll",
    meta: {
      title: "库存记录",
      icon: "sms-subject"
    },
    children: [{
      path: "stocksList",
      name: "stocksList",
      component: () => import("@/views/srm/stocks/list"),
      meta: {
        title: "库存记录",
        icon: "sms-subject"
      }
    }]
  },
  {
    path: "/supplist",
    component: Layout,
    redirect: "/supplist/supplist",
    name: "supplistMng",
    meta: {
      title: "供应商列表",
      icon: "sms-subject"
    },
    children: [{
        path: "supplist",
        name: "supplist",
        component: () => import("@/views/srm/supplist/supplist"),
        meta: {
          title: "供应商列表",
          icon: "sms-subject"
        }
      },
      {
        path: "supplierPoints",
        name: "supplierPoints",
        component: () => import("@/views/srm/supplist/supplierPoints"),
        meta: {
          title: "供应商返佣",
          icon: "sms-subject"
        }
      },
      {
        path: "uploadSullierInfo",
        name: "uploadSullierInfo",
        component: () => import("@/views/srm/supplist/uploadSullierInfo"),
        meta: {
          title: "实名绑卡",
          icon: "sms-subject"
        },
        hidden: true
      },
      {
        path: "thirdPushSuppliers",
        name: "thirdPushSuppliers",
        component: () => import("@/views/thirdPush/suppliers"),
        meta: {
          title: "查看供应商",
          icon: "sms-subject"
        },
        hidden: true
      }
    ]
  },
  {
    path: "/doctors",
    component: Layout,
    redirect: "/doctors/doctors",
    name: "doctorsMng",
    meta: {
      title: "老师管理",
      icon: "user"
    },
    children: [{
        path: "doctors",
        name: "doctors",
        component: () => import("@/views/srm/doctors/doctors"),
        meta: {
          title: "老师管理",
          icon: "user"
        }
      },
      {
        path: "doctorDetail",
        name: "doctorDetail",
        component: () => import("@/views/srm/doctors/doctorDetail"),
        meta: {
          title: "老师详情",
          icon: "user"
        },
        hidden: true
      },
      {
        path: "thirdPushDoctors",
        name: "thirdPushDoctors",
        component: () => import("@/views/thirdPush/doctors"),
        meta: {
          title: "查看老师",
          icon: "user"
        },
        hidden: true
      },
      {
        path: "patientPage",
        name: "patientPage",
        component: () => import("@/views/srm/patient/patientPage"),
        meta: {
          title: "客户列表",
          icon: "sms-subject"
        },
        hidden: true
      }
    ]
  },
  {
    path: "/supplierAgent",
    component: Layout,
    redirect: "/supplierAgent/supplierAgentList",
    name: "supplierAgent",
    meta: {
      title: "供应商总代",
      icon: "user"
    },
    children: [{
      path: "supplierAgentList",
      name: "supplierAgentList",
      component: () => import("@/views/srm/supplierAgent/index"),
      meta: {
        title: "供应商总代",
        icon: "user"
      }
    }]
  },
  /*{
    path: "/supplierAgentProduct",
    component: Layout,
    redirect: "/supplierAgentProduct/productList",
    name: "supplierAgentProduct",
    meta: {
      title: "供应商总代产品",
      icon: "user"
    },
    children: [{
      path: "productList",
      name: "productList",
      component: () => import("@/views/srm/supplierAgentProduct/index"),
      meta: {
        title: "供应商总代产品",
        icon: "user"
      }
    }, {
      path: "editDrugs",
      name: "editDrugs",
      component: () => import("@/views/srm/supplierAgentProduct/editDrugs"),
      meta: {
        title: "编辑产品",
        icon: "product-list"
      },
      hidden: true
    }]
  },*/
  {
    path: "/score",
    component: Layout,
    redirect: "/score/scoreGetRecords",
    name: "scoreMng",
    meta: {
      title: "积分管理",
      icon: "user"
    },
    children: [{
        path: "scoreGetRecords",
        name: "scoreGetRecords",
        component: () => import("@/views/srm/score/getRecords"),
        meta: {
          title: "积分记录",
          icon: "user"
        }
      },
      {
        path: "scoreApplyRecords",
        name: "scoreApplyRecords",
        component: () => import("@/views/srm/score/applyRecords"),
        meta: {
          title: "积分体现申请",
          icon: "user"
        }
      },
      {
        path: "scoreManualRecords",
        name: "scoreManualRecords",
        component: () => import("@/views/srm/score/scoreVerify"),
        meta: {
          title: "发放扣减记录",
          icon: "user"
        }
      }
    ]
  },
  {
    path: "/productMng",
    component: Layout,
    redirect: "/productMng/productList",
    name: "productMng",
    meta: {
      title: "产品管理",
      icon: "user"
    },
    children: [{
        path: "productList",
        name: "productList",
        component: () => import("@/views/srm/supplierAgentProduct/index"),
        meta: {
          title: "供应商总代产品",
          icon: "user"
        }
      }, {
        path: "editDrugs",
        name: "editDrugs",
        component: () => import("@/views/srm/supplierAgentProduct/editDrugs"),
        meta: {
          title: "编辑产品",
          icon: "product-list"
        },
        hidden: true
      },
      /*{
        path: "productSalesman",
        name: "productSalesman",
        component: () => import("@/views/srm/productsBind/productSalesman"),
        meta: {
          title: "代表绑定",
          icon: "login-mall"
        }
      }, {
        path: "productDoctors",
        name: "productDoctors",
        component: () => import("@/views/srm/productsBind/productDoctors"),
        meta: {
          title: "医生绑定",
          icon: "login-mall"
        }
      }, {
        path: "bindProducts",
        name: "bindProducts",
        component: () => import("@/views/srm/productsBind/products"),
        meta: {
          title: "产品绑定",
          icon: "login-mall"
        }
      },*/
      {
        path: "appProductCenter",
        name: "appProductCenter",
        component: () => import("@/views/srm/appProductCenter/index"),
        meta: {
          title: "产品中心列表",
          icon: "product-cate"
        }
      },
      {
        path: "platdrugs",
        name: "platdrugs",
        component: () => import("@/views/srm/platDrugs/platDrugs"),
        meta: {
          title: "产品申请管理",
          icon: "product-cate"
        }
      }, {
        path: "drugsEditLog",
        name: "drugsEditLog",
        component: () => import("@/views/srm/platDrugs/editlog"),
        meta: {
          title: "产品编辑日志",
          icon: "product-cate"
        }
      }, {
        path: "platEditDrugs",
        name: "platEditDrugs",
        component: () => import("@/views/pharmacyMS/drugs/editDrugs"),
        meta: {
          title: "编辑产品",
          icon: "product-list"
        },
        hidden: true
      },
      {
        path: "editDrugs",
        name: "editDrugs",
        component: () => import("@/views/pharmacyMS/drugs/editDrugs"),
        meta: {
          title: "编辑产品",
          icon: "product-list"
        },
        hidden: true
      },
      {
        path: "productRequirement",
        name: "productRequirement",
        component: () => import("@/views/srm/productRequirement/index"),
        meta: {
          title: "老师产品需求",
          icon: "user"
        }
      },
    ]
  },
  {
    path: "/officialAccount",
    component: Layout,
    redirect: "/officialAccount/officialAccountList",
    name: "officialAccountMng",
    meta: {
      title: "公众客户列表",
      icon: "user"
    },
    children: [{
      path: "officialAccountList",
      name: "officialAccountList",
      component: () => import("@/views/srm/officialAccount/list"),
      meta: {
        title: "公众客户列表",
        icon: "user"
      }
    }]
  },
  {
    path: "/blackListAccount",
    component: Layout,
    redirect: "/blackListAccount/blackList",
    name: "blackListMng",
    meta: {
      title: "拉黑用户管理",
      icon: "user"
    },
    children: [{
      path: "blackList",
      name: "blackList",
      component: () => import("@/views/srm/blackList/index"),
      meta: {
        title: "拉黑用户管理",
        icon: "user"
      }
    }]
  },
  {
    path: "/hospitals",
    component: Layout,
    redirect: "/hospitals/hospitals",
    name: "hospitalsMng",
    meta: {
      title: "医院管理",
      icon: "user"
    },
    children: [{
      path: "hospitals",
      name: "hospitals",
      component: () => import("@/views/srm/hospitals/hospitals"),
      meta: {
        title: "医院管理",
        icon: "user"
      }
    }]
  },
  {
    path: "/pharmacyOrder",
    component: Layout,
    redirect: "/pharmacyOrder/doctors",
    name: "pharmacyOrderMng",
    meta: {
      title: "订单总览",
      icon: "user"
    },
    children: [{
      path: "order",
      name: "order",
      component: () => import("@/views/pharmacyOrder/order/order"),
      meta: {
        title: "订单总览",
        icon: "user"
      }
    }, {
      path: "chineseMedicineOrder",
      name: "chineseMedicineOrder",
      component: () => import("@/views/pharmacyOrder/order/chineseMedicineOrder"),
      meta: {
        title: "中药订单",
        icon: "user"
      }
    }, {
      path: "manualOrder",
      name: "manualOrder",
      component: () => import("@/views/pharmacyOrder/order/manualOrder"),
      meta: {
        title: "人工订单",
        icon: "user"
      }
    }, {
      path: "thirdPushOrderList",
      name: "thirdPushOrderList",
      component: () => import("@/views/thirdPush/thirdOrderList"),
      meta: {
        title: "订单明细",
        icon: "sms-subject"
      },
      hidden: true
    }]
  },
  {
    path: "/awardMng",
    component: Layout,
    redirect: "/awardMng/awardOrder",
    name: "awardMng",
    meta: {
      title: "打赏订单",
      icon: "user"
    },
    children: [{
      path: "awardOrder",
      name: "awardOrder",
      component: () => import("@/views/srm/award/orderList"),
      meta: {
        title: "打赏订单",
        icon: "user"
      }
    }]
  },
  {
    path: "/consultFeeMng",
    component: Layout,
    redirect: "/consultFeeMng/consultFeeOrder",
    name: "consultFeeMng",
    meta: {
      title: "咨询费管理",
      icon: "user"
    },
    children: [{
      path: "consultFeeOrder",
      name: "consultFeeOrder",
      component: () => import("@/views/srm/consultFeeMng/index"),
      meta: {
        title: "咨询费管理",
        icon: "user"
      }
    }]
  },
  {
    path: "/pharmacys",
    component: Layout,
    redirect: "/pharmacys/pharmacys",
    name: "pharmacysMng",
    meta: {
      title: "药房管理",
      icon: "login-mall"
    },
    children: [{
        path: "pharmacys",
        name: "pharmacys",
        component: () => import("@/views/srm/pharmacys/pharmacys"),
        meta: {
          title: "药房管理",
          icon: "login-mall"
        }
      },
      {
        path: "addPharmacy",
        name: "addPharmacy",
        component: () => import("@/views/srm/pharmacys/addPharmacy"),
        meta: {
          title: "新增药房",
          icon: "login-mall"
        },
        hidden: true
      },
      {
        path: "editPharmacy",
        name: "editPharmacy",
        component: () => import("@/views/srm/pharmacys/editPharmacy"),
        meta: {
          title: "编辑药房",
          icon: "login-mall"
        },
        hidden: true
      },
      {
        path: "uploadPharmacyInfo",
        name: "uploadPharmacyInfo",
        component: () => import("@/views/srm/pharmacys/uploadPharmacyInfo"),
        meta: {
          title: "上传药房信息",
          icon: "login-mall"
        },
        hidden: true
      },
      {
        path: "thirdPushPharmacys",
        name: "thirdPushPharmacys",
        component: () => import("@/views/thirdPush/pharmacys"),
        meta: {
          title: "查看药房",
          icon: "sms-subject"
        },
        hidden: true
      }
    ]
  },
  {
    path: "/medicineManager",
    component: Layout,
    redirect: "/medicineManager/managerList",
    name: "medicineManagerMng",
    meta: {
      title: "产品管理员",
      icon: "login-mall"
    },
    children: [{
        path: "managerList",
        name: "managerList",
        component: () => import("@/views/srm/medicineManager/list"),
        meta: {
          title: "产品管理员",
          icon: "login-mall"
        }
      },
      {
        path: "thirdPushMedicines",
        name: "thirdPushMedicines",
        component: () => import("@/views/thirdPush/medicines"),
        meta: {
          title: "产品列表",
          icon: "product-list"
        },
        hidden: true
      }
    ]
  },
  {
    path: "/prescriptionManager",
    component: Layout,
    redirect: "/prescriptionManager/prescriptionList",
    name: "prescriptionManagerMng",
    meta: {
      title: "处方单",
      icon: "login-mall"
    },
    children: [{
      path: "prescriptionList",
      name: "prescriptionList",
      component: () => import("@/views/srm/prescription/list"),
      meta: {
        title: "处方单列表",
        icon: "login-mall"
      }
    }]
  },
  {
    path: "/uploadMedicine",
    component: Layout,
    redirect: "/uploadMedicine/uploadMedicineList",
    name: "uploadMedicineMng",
    meta: {
      title: "上传产品",
      icon: "login-mall"
    },
    children: [{
        path: "uploadMedicineList",
        name: "uploadMedicineList",
        component: () => import("@/views/srm/uploadMedicine/list"),
        meta: {
          title: "上传产品",
          icon: "login-mall"
        }
      },
      {
        path: "editDrugs",
        name: "editDrugs",
        component: () => import("@/views/pharmacyMS/drugs/editDrugs"),
        meta: {
          title: "编辑产品",
          icon: "product-list"
        },
        hidden: true
      },
    ]
  },
  {
    path: "/qrCodeMedicine",
    component: Layout,
    redirect: "/qrCodeMedicine/qrCodeMedicineList",
    name: "qrCodeMedicineMng",
    meta: {
      title: "二维码产品",
      icon: "login-mall"
    },
    children: [{
      path: "qrCodeMedicineList",
      name: "qrCodeMedicineList",
      component: () => import("@/views/srm/qrCodeMedicine/list"),
      meta: {
        title: "二维码产品",
        icon: "login-mall"
      }
    }]
  },
  {
    path: "/countBI",
    component: Layout,
    redirect: "/countBI/interactionBI",
    name: "countBI",
    meta: {
      title: "BI分析",
      icon: "login-mall"
    },
    children: [{
      path: "interactionBI",
      name: "interactionBI",
      component: () => import("@/views/srm/countData/interactionBI"),
      meta: {
        title: "互动咨询BI",
        icon: "login-mall"
      }
    }, {
      path: "serviceOrderBI",
      name: "serviceOrderBI",
      component: () => import("@/views/srm/countData/serviceOrderBI"),
      meta: {
        title: "服务订单BI",
        icon: "login-mall"
      }
    }]
  },
  {
    path: "/countData",
    component: Layout,
    redirect: "/countData/summary",
    name: "countData",
    meta: {
      title: "数据总览",
      icon: "login-mall"
    },
    children: [{
        path: "summary",
        name: "summary",
        component: () => import("@/views/srm/countData/countData"),
        meta: {
          title: "数据总览",
          icon: "login-mall"
        }
      }, {
        path: "countDrugs",
        name: "countDrugs",
        component: () => import("@/views/srm/countData/countDrugs"),
        meta: {
          title: "产品销量统计",
          icon: "login-mall"
        }
      }, {
        path: "multiDimensionCount",
        name: "multiDimensionCount",
        component: () => import("@/views/srm/countData/multiDimensionCount"),
        meta: {
          title: "订单多维度统计",
          icon: "login-mall"
        }
      }, {
        path: "scoreMultiCount",
        name: "scoreMultiCount",
        component: () => import("@/views/srm/countData/scoreMultiCount"),
        meta: {
          title: "积分多维度统计",
          icon: "login-mall"
        }
      }, {
        path: "saleCountData",
        name: "saleCountData",
        component: () => import("@/views/srm/countData/saleDatas"),
        meta: {
          title: "销售明细",
          icon: "login-mall"
        }
      }, {
        path: "outHospitalMultiDimensionCount",
        name: "outHospitalMultiDimensionCount",
        component: () => import("@/views/srm/countData/outHospitalMultiDimensionCount"),
        meta: {
          title: "院外多维度统计",
          icon: "login-mall"
        }
      }
      /*,{
              path: "outHospitalSaleCountData",
              name: "outHospitalSaleCountData",
              component: () => import("@/views/srm/countData/outHospitalSaleDatas"),
              meta: {
                title: "院外销售明细",
                icon: "login-mall"
              }
            }*/
    ]
  },
  {
    path: "/drugsDepartMng",
    component: Layout,
    redirect: "/drugsDepartMng/drugsDepart",
    name: "drugsDepartMng",
    meta: {
      title: "产品科室",
      icon: "login-mall"
    },
    children: [{
      path: "drugsDepart",
      name: "drugsDepart",
      component: () => import("@/views/srm/platDrugs/depart"),
      meta: {
        title: "科室管理",
        icon: "login-mall"
      }
    }]
  },
  {
    path: "/doctorFollowUp",
    component: Layout,
    redirect: "/doctorFollowUp/doctorDepart",
    name: "doctorFollowUp",
    meta: {
      title: "老师随访",
      icon: "login-mall"
    },
    children: [{
      path: "doctorDepart",
      name: "doctorDepart",
      component: () => import("@/views/srm/doctorFollowUp/depart"),
      meta: {
        title: "科室管理",
        icon: "login-mall"
      }
    }]
  },
  {
    path: "/vipMng",
    component: Layout,
    redirect: "/vipMng/membershipDrugs",
    name: "vipMng",
    meta: {
      title: "VIP商城",
      icon: "login-mall"
    },
    children: [{
        path: "vipOrder",
        name: "vipOrder",
        component: () => import("@/views/pharmacyOrder/order/vipOrder"),
        meta: {
          title: "VIP充值订单",
          icon: "user"
        }
      }, {
        path: "vipShopOrder",
        name: "vipShopOrder",
        component: () => import("@/views/pharmacyOrder/order/vipShopOrder"),
        meta: {
          title: "VIP商城订单",
          icon: "user"
        }
      },
      {
        path: "vipPriceSet",
        name: "vipPriceSet",
        component: () => import("@/views/srm/shopPriceSetting/index"),
        meta: {
          title: "店铺会员费设置",
          icon: "product-cate"
        }
      },
      {
        path: "membershipDrugs",
        name: "membershipDrugs",
        component: () => import("@/views/srm/membershipDrugs/membershipDrugs"),
        meta: {
          title: "会员产品管理",
          icon: "product-cate"
        }
      },
      {
        path: "editMembershipDrugs",
        name: "editMembershipDrugs",
        component: () => import("@/views/srm/membershipDrugs/editDrugs"),
        meta: {
          title: "编辑会员产品",
          icon: "product-list"
        },
        hidden: true
      },
      {
        path: "vipDepart",
        name: "vipDepart",
        component: () => import("@/views/srm/vipMng/vipDepart"),
        meta: {
          title: "VIP科室管理",
          icon: "login-mall"
        }
      },
      {
        path: "vipGetRecords",
        name: "vipGetRecords",
        component: () => import("@/views/srm/score/vipGetRecords"),
        meta: {
          title: "VIP商城积分记录",
          icon: "user"
        }
      },
      {
        path: "vipOfficalAccount",
        name: "vipOfficalAccount",
        component: () => import("@/views/srm/vipMng/officalAccount"),
        meta: {
          title: "会员开店",
          icon: "user"
        }
      },
      {
        path: "vipUser",
        name: "vipUser",
        component: () => import("@/views/srm/vipUser/index"),
        meta: {
          title: "VIP用户",
          icon: "user"
        }
      }
    ]
  },
  {
    path: "/systemSetting",
    component: Layout,
    redirect: "/systemSetting/sysNotice",
    name: "systemSetting",
    meta: {
      title: "系统设置",
      icon: "login-mall"
    },
    children: [{
      path: "sysNotice",
      name: "sysNotice",
      component: () => import("@/views/srm/setting/notice"),
      meta: {
        title: "公告管理",
        icon: "login-mall"
      }
    }]
  },
  {
    path: "/historyRecords",
    component: Layout,
    redirect: "/historyRecords/productEditHis",
    name: "historyRecords",
    meta: {
      title: "历史记录",
      icon: "login-mall"
    },
    children: [{
      path: "productEditHis",
      name: "productEditHis",
      component: () => import("@/views/historyRecords/productEdit"),
      meta: {
        title: "产品修改记录",
        icon: "login-mall"
      }
    }]
  },
  {
    path: "/salesman",
    component: Layout,
    redirect: "/salesman/salesmanList",
    name: "salesmanMng",
    meta: {
      title: "代表管理",
      icon: "login-mall"
    },
    children: [{
        path: "salesmanList",
        name: "salesmanList",
        component: () => import("@/views/srm/salesman/salesman"),
        meta: {
          title: "代表列表",
          icon: "login-mall"
        }
      },
      {
        path: "salesmanPoints",
        name: "salesmanPoints",
        component: () => import("@/views/srm/salesman/salesmanPoints"),
        meta: {
          title: "代表返佣",
          icon: "login-mall"
        }
      },
      {
        path: "teamPerformance",
        name: "teamPerformance",
        component: () => import("@/views/srm/salesman/teamPerformance"),
        meta: {
          title: "战队成绩",
          icon: "login-mall"
        }
      },

      {
        path: "salesmanThirdPushDoctors",
        name: "salesmanThirdPushDoctors",
        component: () => import("@/views/thirdPush/doctors"),
        meta: {
          title: "查看老师",
          icon: "user"
        },
        hidden: true
      },
      {
        path: "salesmanThirdPatientPage",
        name: "salesmanThirdPatientPage",
        component: () => import("@/views/srm/patient/patientPage"),
        meta: {
          title: "客户列表",
          icon: "sms-subject"
        },
        hidden: true
      },
      {
        path: "thirdPushSalesman",
        name: "thirdPushSalesman",
        component: () => import("@/views/thirdPush/salesmans"),
        meta: {
          title: "查看代表",
          icon: "login-mall"
        },
        hidden: true
      }
    ]
  },
  {
    path: "/productsBind",
    component: Layout,
    redirect: "/productsBind/productSalesman",
    name: "productsBindMng",
    meta: {
      title: "产品绑定管理",
      icon: "login-mall"
    },
    children: [{
      path: "productSalesman",
      name: "productSalesman",
      component: () => import("@/views/srm/productsBind/productSalesman"),
      meta: {
        title: "代表绑定",
        icon: "login-mall"
      }
    }, {
      path: "productDoctors",
      name: "productDoctors",
      component: () => import("@/views/srm/productsBind/productDoctors"),
      meta: {
        title: "医生绑定",
        icon: "login-mall"
      }
    }, {
      path: "bindProducts",
      name: "bindProducts",
      component: () => import("@/views/srm/productsBind/products"),
      meta: {
        title: "产品绑定",
        icon: "login-mall"
      }
    }]
  },
  {
    path: "/recommendedDrugs",
    component: Layout,
    redirect: "/recommendedDrugs/recommendedDrugs",
    name: "recommendedDrugsMng",
    meta: {
      title: "招商产品管理",
      icon: "product-add"
    },
    children: [{
        path: "recommendeddrugs",
        name: "recommendeddrugs",
        component: () =>
          import("@/views/srm/recommendedDrugs/recommendedDrugs"),
        meta: {
          title: "招商产品管理",
          icon: "product-add"
        }
      },
      {
        path: "editRecommandedDrugs",
        name: "editRecommandedDrugs",
        component: () =>
          import("@/views/srm/recommendedDrugs/editRecommandedDrugs"),
        meta: {
          title: "编辑产品",
          icon: "ums-admin"
        },
        hidden: true
      }
    ]
  },
  {
    path: "/drugStocks",
    component: Layout,
    redirect: "/drugStocks/drugStocks",
    name: "drugStocksMng",
    meta: {
      title: "产品库存统计",
      icon: "product-cate"
    },
    children: [{
      path: "drugStocks",
      name: "drugStocks",
      component: () => import("@/views/srm/drugStocks/index"),
      meta: {
        title: "产品库存统计",
        icon: "product-cate"
      }
    }]
  },

  /*{
    path: "/platdrugs",
    component: Layout,
    redirect: "/platdrugs/platdrugs",
    name: "platDrugsMng",
    meta: {
      title: "产品申请管理",
      icon: "product-cate"
    },
    children: [{
        path: "platdrugs",
        name: "platdrugs",
        component: () => import("@/views/srm/platDrugs/platDrugs"),
        meta: {
          title: "产品申请管理",
          icon: "product-cate"
        }
      }, {
        path: "platEditDrugs",
        name: "platEditDrugs",
        component: () => import("@/views/pharmacyMS/drugs/editDrugs"),
        meta: {
          title: "编辑产品",
          icon: "product-list"
        },
        hidden: true
      },
      {
        path: "editDrugs",
        name: "editDrugs",
        component: () => import("@/views/pharmacyMS/drugs/editDrugs"),
        meta: {
          title: "编辑产品",
          icon: "product-list"
        },
        hidden: true
      }
    ]
  },*/
  {
    path: "/bizmng",
    component: Layout,
    redirect: "/bizmng/bizview",
    name: "bizmng",
    meta: {
      title: "财务管理",
      icon: "product-cate"
    },
    children: [{
        path: "bizview",
        name: "bizview",
        component: () => import("@/views/biz/bizmng/bizview"),
        meta: {
          title: "财务一览",
          icon: "product-cate"
        }
      },
      {
        path: "platformBiz",
        name: "platformBiz",
        component: () => import("@/views/biz/bizmng/platformBiz"),
        meta: {
          title: "平台财务",
          icon: "product-cate"
        }
      },
      {
        path: "withdrawApply",
        name: "withdrawApply",
        component: () => import("@/views/money/withdrawApply/withdrawApply"),
        meta: {
          title: "提现申请",
          icon: "user"
        }
      },
      {
        path: "withdrawRecord",
        name: "withdrawRecord",
        component: () => import("@/views/biz/bizmng/withdrawRecord"),
        meta: {
          title: "提现明细",
          icon: "product-cate"
        }
      },
      {
        path: "rechargeRecord",
        name: "rechargeRecord",
        component: () => import("@/views/biz/bizmng/rechargeRecord"),
        meta: {
          title: "充值记录",
          icon: "product-cate"
        }
      },
      {
        path: "amountRecord",
        name: "amountRecord",
        component: () => import("@/views/biz/bizmng/amountRecord"),
        meta: {
          title: "平台收入明细",
          icon: "product-cate"
        }
      },
      {
        path: "amountRecord1",
        name: "amountRecord1",
        component: () => import("@/views/biz/bizmng/amountRecord1"),
        meta: {
          title: "供应商收入明细",
          icon: "product-cate"
        }
      },
      {
        path: "amountRecord2",
        name: "amountRecord2",
        component: () => import("@/views/biz/bizmng/amountRecord2"),
        meta: {
          title: "药房收入明细",
          icon: "product-cate"
        }
      },
      {
        path: "amountRecord3",
        name: "amountRecord3",
        component: () => import("@/views/biz/bizmng/amountRecord3"),
        meta: {
          title: "总代收入明细",
          icon: "product-cate"
        }
      }
    ]
  },
  {
    path: "*",
    redirect: "/404",
    hidden: true
  },
  {
    path: "/outHospital",
    component: Layout,
    redirect: "/outHospital/outPharmacy",
    name: "outHospital",
    meta: {
      title: "院外购药管理",
      icon: "login-mall"
    },
    children: [{
        path: "outPharmacy",
        name: "outPharmacy",
        component: () => import("@/views/outHospital/outPharmacy"),
        meta: {
          title: "院外药房",
          icon: "login-mall"
        }
      }, {
        path: "outHospitalProducts",
        name: "outHospitalProducts",
        component: () => import("@/views/outHospital/outHospitalProducts"),
        meta: {
          title: "院外药房产品",
          icon: "login-mall"
        }
      }, {
        path: "outOrders",
        name: "outOrders",
        component: () => import("@/views/outHospital/outOrders"),
        meta: {
          title: "院外订单",
          icon: "login-mall"
        }
      },
      {
        path: "outPharmacyMembers",
        name: "outPharmacyMembers",
        component: () => import("@/views/outHospital/outPharmacyMembers"),
        meta: {
          title: "院外药房员工",
          icon: "login-mall"
        }
      },
      {
        path: "outDoctors",
        name: "outDoctors",
        component: () => import("@/views/outHospital/outDoctors"),
        meta: {
          title: "院外老师管理",
          icon: "login-mall"
        }
      }
    ]
  },
  {
    path: "/partners",
    component: Layout,
    redirect: "/partners/partnerlist",
    name: "partners",
    meta: {
      title: "合伙人管理",
      icon: "login-mall"
    },
    children: [{
      path: "partnerlist",
      name: "partnerlist",
      component: () => import("@/views/srm/partners/partnerlist"),
      meta: {
        title: "合伙人管理",
        icon: "login-mall"
      }
    }, {
      path: "partnerDoctorlist",
      name: "partnerDoctorlist",
      component: () => import("@/views/srm/partners/doctorList"),
      meta: {
        title: "老师列表",
        icon: "login-mall"
      }
    }]
  },
  {
    path: "/financePartner",
    component: Layout,
    redirect: "/financePartner/financePartnerlist",
    name: "financePartner",
    meta: {
      title: "合伙经济人管理",
      icon: "login-mall"
    },
    children: [{
      path: "financePartnerlist",
      name: "financePartnerlist",
      component: () => import("@/views/srm/financePartner/partnerlist"),
      meta: {
        title: "合伙经济人管理",
        icon: "login-mall"
      }
    }]
  },
  {
    path: "/AIMng",
    component: Layout,
    redirect: "/AIMng/AIChat",
    name: "AIMng",
    meta: {
      title: "分公司管理",
      icon: "sms-subject"
    },
    children: [{
      path: "AIChat",
      name: "AIChat",
      component: () => import("@/views/srm/AIChat/index"),
      meta: {
        title: "分公司列表",
        icon: "sms-subject"
      }
    }]
  },
  /*{
    path: "/memberShopProducts",
    component: Layout,
    redirect: "/memberShopProducts/msProducts",
    name: "memberShopProducts",
    meta: {
      title: "会员产品管理",
      icon: "login-mall"
    },
    children: [{
      path: "msProducts",
      name: "msProducts",
      component: () => import("@/views/memberShop/products/index"),
      meta: {
        title: "会员产品管理",
        icon: "login-mall"
      }
    }]
  },*/
];

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
});



// WEBPACK FOOTER //
// ./src/router/index.js